import React from "react";
import styled, { useTheme } from "styled-components/native";
import { ButtonType } from "@components/atoms/Button/types";
import { useTranslation } from "react-i18next";
import { useLinkTo } from "@react-navigation/native";
import MessageContainer from "@components/molecules/MessageContainer";
import { VDBIcons } from "@utils/VDBIcons";
import { RedirectFunc } from "./utils";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useDispatch } from "react-redux";
import { fallbackIfEmptyDeeplink } from "@scenes/favorites/utils/FavoritesUtils";

const EmptyView = ({ deepLink }: { deepLink?: string }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const linkTo = useLinkTo();
  const userInfo = useUserInfo();
  const dispatch = useDispatch();
  const navigateToExplore = () => {
    fallbackIfEmptyDeeplink(userInfo, dispatch, theme);
  };

  return (
    <Overlay>
      <MessageContainer
        messageTitle={t("orderCart.emptyView.nothingHere.text")}
        message={t("orderCart.emptyView.searchAndItems.text")}
        iconName={VDBIcons.BULK_LIST_SHOPPING_CART}
        iconColor={theme["core-03"]}
        buttons={{
          type: ButtonType.primary,
          title: t("orderCart.emptyView.button.exploreInventory.text"),
          onPressAction: () => {
            deepLink ? RedirectFunc(deepLink, linkTo) : navigateToExplore();
          },
          textTypographyStyle: "H3-M",
          width: 343,
        }}
      />
    </Overlay>
  );
};

const Overlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding-bottom: 110px;
`;

export default EmptyView;
